import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Divider } from 'components/ui';
import localeUtils from 'utils/LanguageLocale';
import ProductCompareTool from 'components/ProductPage/ProductCompareTool';
import SimilarProductFilters from './SimilarProductFilters.f';
import { useFilteredRecommendations } from './useFilteredRecommendations';
import bpRedesignedUtils from 'utils/BeautyPreferencesRedesigned';
import recServiceUtils from 'utils/RecommendationService';
import productUtils from 'utils/product';
import pdpCompareUtils from 'utils/pdpCompare';

const { transformRecommendationsForCarousel } = recServiceUtils;

const SimilarProductCarousel = ({ isSmallView, currentProduct }) => {
    const { podId, productRecommendationsData, isFetching, updateFilter } = useFilteredRecommendations(currentProduct);
    const { recommendations = [], resultId = '', totalNumResults = 0 } = productRecommendationsData;
    const recommendationsForCarousel = transformRecommendationsForCarousel(recommendations);
    const featuresData = currentProduct?.cxsContent?.similarProductsComparison?.featuresData;
    const currentPrice = currentProduct?.currentSku?.listPrice;
    const title = localeUtils.isFRCanada() ? 'Produits similaires' : `Similar ${currentProduct?.parentCategory?.displayName}`;
    const parentCategoryId = productUtils.findProductRootParentCategoryId(currentProduct?.parentCategory);
    const masterlistWorld = bpRedesignedUtils.getMasterListRefinementWorldByCategoryId(parentCategoryId);
    const pdpCompareAttributes = pdpCompareUtils.getPdpCompareAttributes(masterlistWorld?.key);

    return (
        <Box
            lineHeight='tight'
            marginBottom={[6, 7]}
        >
            <Divider />
            <ProductCompareTool
                skuList={recommendationsForCarousel}
                similarProductVariants={
                    <SimilarProductFilters
                        featuresData={featuresData}
                        selectedVariation={podId}
                        onFilterChange={updateFilter}
                        currentPrice={currentPrice}
                    />
                }
                isLoading={isFetching}
                isSmallView={isSmallView}
                title={title}
                podId={podId}
                resultId={resultId}
                totalResults={totalNumResults}
                isCarousel
                pdpCompareAttributes={pdpCompareAttributes}
                currentProduct={currentProduct}
            />
        </Box>
    );
};

SimilarProductCarousel.propTypes = {
    isSmallView: PropTypes.bool,
    currentProduct: PropTypes.object
};

export default wrapFunctionalComponent(SimilarProductCarousel, 'SimilarProductCarousel');
